import { title } from 'process';
import { useEffect, useState } from 'react';
import Button from 'src/components/button';
import ImageSlider from 'src/components/ImageSlider';
import { toastAlert } from 'src/utils/toastAlert';

const Image = () => {
  const btnTitle: any = (
    <>
      Drag and drop image here or upload <b />
      <span className="text-xs font-normal text-secondary-0">
        Supported file types: .jpg, .png, .webp
      </span>
    </>
  );

  const [saveSlider, setsaveSlider] = useState<boolean>(false);
  const [isSubmitting, setisSubmitting] = useState<boolean>(false);

  const ImageSlides = [
    { title: 'Slider Images (only 5)', slider: 'imageSlider' },
    {
      title: 'Restaurant Images (only 5)',
      slider: 'restaurantImages',
    },
    {
      title: 'Dish Images',
      slider: 'dishImages',
    },
    {
      title: 'Menu Images',
      slider: 'menuImages',
    },
  ];

  const CheckStatus = (message: { success: boolean; response: string }) => {
    setsaveSlider(false);
    message?.success
      ? toastAlert('success', `Slides has been  successfully saved`)
      : toastAlert('error', message?.response);
  };

  useEffect(() => {
    !isSubmitting &&
      saveSlider &&
      CheckStatus({
        success: true,
        response: 'Slides has been  successfully saved',
      });
  }, [saveSlider, isSubmitting]);

  return (
    <>
      <div className="grid grid-cols-2  flex-wrap justify-around gap-x-6 gap-y-9">
        {ImageSlides.map(
          (slide: { title: string; slider: string }, index: number) => (
            <div key={index} className="w-[334px]">
              <ImageSlider
                title={slide?.title}
                btnLabel={btnTitle}
                slider={slide?.slider}
                CheckStatus={CheckStatus}
                issaveSlider={saveSlider}
                isSubmitting={isSubmitting}
                SetIsSubmitting={setisSubmitting}
              />
            </div>
          )
        )}

        <div className="col-span-2	text-end mx-7">
          <Button
            text={'Save Details'}
            variant="primary"
            onClick={() => setsaveSlider(true)}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    </>
  );
};

export default Image;
